var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAnalysisGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#86888C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.8,143L357,4.1c-2.6-2.7-6.3-4.2-10-4.2c-70.7,0-150.7,0-165.5,0c-18,0.1-29.3,11.2-29.3,29.2 c0,2.6,0,25.1,0,44.3v13.8C94.9,107.4,53.8,162,53.8,226.3c0,35.7,12.7,68.4,33.8,93.9L4.7,406.3c-2.6,2.6-4,6.2-4,9.9 c0,7.9,6.4,14.2,14.2,14.2c3.8,0,7.5-1.6,10.3-4.3l82.6-85.8c13.1,10.8,28.1,19.3,44.4,25.1c0,79,0,92.1,0,104.6 c0,18.2,11.2,29.5,29.3,29.5c16.2,0,168,0,217.9,0h48.8c7.8,0,15.4,0,23.1-0.1c17.4-0.1,28.7-11.3,28.7-28.8c0-12,0-213.8,0-317.6 C500,149.2,498.5,145.6,495.8,143z M451.3,138.9h-35c-16.5,0-30.5-5.1-40.2-15s-14.9-23.7-14.9-40.3c0-19.5,0-27.8,0-35l10.6,10.6 L451.3,138.9z M201.3,107.3c31.6-0.1,61.9,12.5,84.2,34.8c22.4,22.3,34.9,52.5,34.9,84.1c0,65.7-53.2,119-118.9,119 c-65.7,0.1-119-53.2-119-118.9C82.3,160.6,135.5,107.3,201.3,107.3z M471.5,471h-0.3c-13.2,0-26.3,0-39.5,0h-32.3 c-49.8,0-201.6,0-217.8,0c-0.3,0-0.6,0-0.9,0c0-0.3,0-0.6,0-1c0-12.1,0-24.8,0-97.7c6.7,0.9,13.6,1.4,20.6,1.4 c39.2,0.1,76.7-15.4,104.2-43.2c27.7-27.6,43.2-65.1,43.2-104.2c0-81.4-66-147.4-147.4-147.4c-7,0-13.9,0.5-20.6,1.4v-6.8 c0-19.2,0-41.7,0-44.3c0-0.2,0-0.4,0-0.6c0.2,0,0.5,0,0.8,0c13.9,0,84.4,0,151.2,0c0,7.6,0,12.4,0,16.9c0,8.1,0,15.8,0,38.2 c0,24.3,8.1,45.1,23.3,60.4c15.2,15.2,36.1,23.3,60.4,23.3h55.1c0,107,0,291.9,0,303.4C471.5,470.8,471.5,470.9,471.5,471z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnalysisGray);
export default __webpack_public_path__ + "static/media/ic-analysis-gray.bda1907a96fa43894860fc1716bac8ef.svg";
export { ForwardRef as ReactComponent };